//rounding methods: ['up','down','nearest']
export function intToString(value, roundingMethod) {

	var newValue = Math.round(value);

	if (value >= 100 * 1000) {
		var suffixes = ["", "K", "M", "B", "T"];
		var [shortNumber, exponent] = (value).toPrecision(5).split('e');
		exponent = parseInt(exponent, 10);
		shortNumber = cleanFloat(parseFloat(shortNumber) * 1000 * Math.floor(Math.pow(10, exponent % 3 + 1)) / 10000, 1, roundingMethod);

		var suffixNum = Math.floor(exponent / 3);
		var suffix = suffixes[suffixNum] || ` 10^${exponent}`;

		newValue = `${shortNumber}${suffix}`;
	} else {
		newValue = newValue.toString();
	}
	return commaNumber(newValue);
}

export function commaNumber(num){
	num = typeof num === 'string' ? num : num.toString();
	return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

//rounding methods: ['up','down','nearest']
export function cleanFloat(number, digitsPastDecimal, roundingMethod){
	var methods = ['up','down','nearest'];
	var index = methods.indexOf(roundingMethod) > -1 ? methods.indexOf(roundingMethod) : 0;
	var roundingFunction = Math[['ceil','floor','round'][index]];
	return roundingFunction(number * Math.pow(10, digitsPastDecimal)) / Math.pow(10, digitsPastDecimal);
}

window.intToString = intToString;